import BuyItem from 'components/BuyPage/RwdBuy/BuyItem/BuyItem';
import { withBuyItemProps } from 'viewModel/buyPage/rwdBuy/BuyItem/withBuyItemProps';

export default withBuyItemProps(BuyItem);
